import { useMessageSource } from "react-message-source";
import * as Yup from "yup";
import { Gender } from "../../types";

export default function useGenderValidator(): Yup.MixedSchema {
  const { getMessage } = useMessageSource();

  return Yup.mixed()
    .required(getMessage("Validation.message-required"))
    .oneOf(
      [Gender.FEMALE, Gender.MALE],
      getMessage("Validation.message-required"),
    );
}
